/**
 * A full-page error message to show when the user attempts to access something
 * that they don't have permission to see.
 */
import {t} from "@lingui/core/macro";

import PermissionDenied from "@khan/component-screens/permission-denied";

import PageDisplay from "#data-access/page-display.tsx";

import DefaultPageTemplate from "../page-templates/default-page-template.tsx";

export default function PermissionDeniedPage() {
    return (
        <DefaultPageTemplate>
            <PageDisplay
                settings={{
                    title: t`You do not have permission to view this content`,
                    statusCode: 403,
                }}
            >
                <PermissionDenied />
            </PageDisplay>
        </DefaultPageTemplate>
    );
}
